import { EventConstants } from "../../constants";
import { Column, COLUMN_EVENTS } from "./column";
import { submitColumnSettings } from "./ajax";
import { fadeIn, scrollToElement } from "../../helpers/animations";
import { insertAfter } from "../../helpers/elements";
import { uniqid } from "../../helpers/string";
import AcHtmlElement from "../../helpers/html-element";
export class Form {
    constructor(element, services) {
        this.form = element;
        this.services = services;
        this.columns = [];
        this.services.emitEvent(EventConstants.SETTINGS.FORM.LOADED, this);
        this.init();
    }
    init() {
        this.initColumns();
        if (this.isDisabled()) {
            this.disableFields();
            this.disableColumns();
        }
        this.services.emitEvent(EventConstants.SETTINGS.FORM.READY, this);
    }
    getElement() {
        return this.form;
    }
    getColumns() {
        return this.columns;
    }
    getSortedColumns() {
        let result = [];
        this.getElement().querySelectorAll('form.ac-column').forEach(column => {
            let c = this.columns.find(c => c.getName() === column.dataset.columnName);
            if (c) {
                result.push(c);
            }
        });
        return result;
    }
    placeColumn(column, after = null) {
        if (after) {
            insertAfter(column.getElement(), after);
        }
        else {
            this.getElement().querySelector('.ac-columns').append(column.getElement());
        }
        setTimeout(() => {
            scrollToElement(column.getElement(), 300, { offset: -18 });
        }, 300);
        return this;
    }
    createNewColumn() {
        let column = createColumnFromTemplate(this.services);
        this.columns.push(column);
        this.placeColumn(column);
        this.bindColumnEvents(column);
        column.open(300);
        return column;
    }
    isDisabled() {
        return this.form.classList.contains('-disabled');
    }
    getOriginalColumns() {
        return this.columns.filter(column => column.isOriginal());
    }
    disableColumns() {
        this.columns.forEach(col => col.disable());
    }
    initColumns() {
        this.getElement().querySelectorAll('.ac-column').forEach((element) => {
            let column = new Column(element, element.dataset.columnName, this.services);
            this.columns.push(column);
            this.bindColumnEvents(column);
        });
    }
    bindColumnEvents(column) {
        column.events.addListener(COLUMN_EVENTS.REMOVE, () => {
            this.removeColumn(column.getName());
        });
        column.events.addListener(COLUMN_EVENTS.CLONE, () => {
            let cloneColumn = new Column(column.getElement().cloneNode(true), uniqid(), this.services);
            this.columns.push(cloneColumn);
            this.placeColumn(cloneColumn, column.getElement()).bindColumnEvents(cloneColumn);
            column.isOpen() ? cloneColumn.open() : cloneColumn.close();
            fadeIn(cloneColumn.getElement(), 300);
        });
    }
    resetColumns() {
        this.columns.forEach((column) => {
            column.destroy();
        });
        this.columns = [];
    }
    getFormData() {
        let columnData = {};
        let titleElement = this.getElement().querySelector('input[name=title]');
        this.getSortedColumns().forEach(column => {
            columnData[column.getName()] = column.getJson();
        });
        return {
            title: titleElement ? titleElement.value : '',
            list_screen: AC.list_screen,
            list_screen_id: AC.layout,
            columns: columnData,
            settings: this.getPreferences()
        };
    }
    disableFields() {
        this.getElement().querySelectorAll('input, select, button').forEach(el => {
            el.setAttribute('readonly', 'readonly');
            el.setAttribute('disabled', 'disabled');
        });
    }
    submitForm() {
        this.services.emitEvent(EventConstants.SETTINGS.FORM.SAVING, this);
        submitColumnSettings(this.getFormData()).then((response) => {
            if (response.data.success) {
                this.showMessage(response.data.data.message, 'updated');
                AC.layout = response.data.data.list_id;
            }
            else if (response.data) {
                let error = response.data;
                this.showMessage(error.data.message, 'notice notice-warning');
            }
        }).catch(() => {
            this.showMessage(AC.i18n.error.save_settings);
        }).finally(() => {
            this.services.emitEvent(EventConstants.SETTINGS.FORM.SAVED, this);
        });
    }
    showMessage(message, className = 'updated') {
        let element = AcHtmlElement.create('div').addClass('ac-message').addClasses(...className.split(' ')).addHtml(`<p>${message}</p>`).element;
        let messageContainer = document.querySelector('.ac-admin__main');
        messageContainer.querySelectorAll('.ac-message').forEach((el) => el.remove());
        messageContainer.insertAdjacentElement('afterbegin', element);
        fadeIn(element, 600);
    }
    removeColumn(name) {
        this.columns.forEach((c, i) => {
            if (name === c.getName()) {
                this.columns.splice(i, 1);
            }
        });
    }
    getPreferences() {
        let data = {};
        document.querySelectorAll('form[data-form-part=preferences]').forEach(el => {
            let fData = new FormData(el);
            // @ts-ignore
            for (let entry of fData.entries()) {
                let key = entry[0];
                let value = entry[1];
                // @ts-ignore
                let element = el.elements[key];
                data[key] = element.tagName === 'SELECT' && element.hasAttribute('multiple')
                    ? fData.getAll(key)
                    : data[key] = value;
            }
        });
        return data;
    }
}
const createColumnFromTemplate = (services) => {
    let columnElement = document.querySelector('#add-new-column-template .ac-column').cloneNode(true);
    const newColumnName = uniqid();
    columnElement.querySelectorAll('label[for]').forEach(label => {
        let relatedId = label.getAttribute('for');
        if (relatedId) {
            let relatedElement = columnElement.querySelector(`#${relatedId}`);
            if (relatedElement) {
                const newID = relatedId + newColumnName;
                label.setAttribute('for', newID);
                relatedElement.id = newID;
            }
        }
    });
    return new Column(columnElement, newColumnName, services);
};
